import Container from "../components/Container";
import aboutPhoto from "../assets/team_photo_at_gorge_cropped.webp";

export default function About() {
  return (
    <section
      id="about"
      className="bg-white min-h-screen md:h-screen flex items-center py-20 md:py-0"
    >
      <Container>
        <div className="flex flex-col md:flex-row items-center md:items-stretch gap-16 md:gap-12">
          
          {/* Image Column */}
          <div className="md:w-1/2 flex justify-center md:justify-start">
            <img
              src={aboutPhoto}
              alt="About Teddy's Tallow"
              className="
                rounded-3xl shadow-lg
                w-full max-w-lg md:max-w-xl
                object-cover
              "
            />
          </div>

          {/* Text Column */}
          <div className="md:w-1/2 flex flex-col justify-center text-center md:text-left">
            <h2 className="text-5xl sm:text-6xl md:text-6xl lg:text-7xl font-bold mb-10">
              About Teddy’s Tallow
            </h2>

            <p className="text-xl sm:text-2xl md:text-2xl lg:text-3xl text-gray-700 leading-relaxed max-w-xl mx-auto md:mx-0">
              What started as a simple question about food quality turned into a
              fast-growing company built on trust, transparency, and real
              ingredients. Teddy’s Tallow is committed to doing things the
              right way — even when it’s harder.
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
}
